const StzSelectPickerAttributesDefaults = {
  elementTag: 'stz-select-picker',
  inputElement: null,
  useMultiselect: false,
  useSearch: false,
  noClear: false,
  items: []
};

export { StzSelectPickerAttributesDefaults as S };
